import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "dropdown-trigger" }
const _hoisted_3 = ["aria-controls", "disabled"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-times" }, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "icon is-small" }
const _hoisted_7 = ["id"]
const _hoisted_8 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LevelComponent = _resolveComponent("LevelComponent")!

  return (_openBlock(), _createElementBlock("div", {
    "aria-label": $props.name,
    class: _normalizeClass([{ 'is-active': $setup.is_active }, "dropdown"]),
    "aria-checked": "true"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        "aria-controls": $props.name,
        "aria-haspopup": "true",
        class: _normalizeClass(["button", { 'is-disabled': $props.isDisabled}]),
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => ($setup.is_active = !$setup.is_active), ["stop"])),
        disabled: $props.isDisabled
      }, [
        _createVNode(_component_LevelComponent, { class: "is-mobile " }, _createSlots({ _: 2 }, [
          ($props.dropdownArrowOrientation == 'left')
            ? {
                name: "level-left",
                fn: _withCtx(() => [
                  (!$props.options.length)
                    ? _renderSlot(_ctx.$slots, "no-options", { key: 0 })
                    : ($setup.selected && $props.options.length)
                      ? _renderSlot(_ctx.$slots, "selected-option", {
                          key: 1,
                          option: $setup.selected
                        }, () => [
                          _createTextVNode(_toDisplayString($setup.selected), 1)
                        ])
                      : ($props.options.length && !$setup.selected)
                        ? _renderSlot(_ctx.$slots, "default-not-selected-option", { key: 2 })
                        : _createCommentVNode("", true)
                ])
              }
            : {
                name: "level-left",
                fn: _withCtx(() => [
                  _createElementVNode("span", { class: "icon is-small" }, [
                    _createElementVNode("i", {
                      class: _normalizeClass([{
                  'fa-angle-up': $setup.is_active,
                  'fa-angle-down': !$setup.is_active,
                  'emphasize-on-load': $props.highlight

                }, "fal"]),
                      "aria-hidden": "true"
                    }, null, 2)
                  ])
                ])
              },
          ($props.dropdownArrowOrientation == 'left')
            ? {
                name: "level-right",
                fn: _withCtx(() => [
                  ($props.isClearable && $setup.selected && $props.options.length)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => ($setup.onClear && $setup.onClear(...args)), ["stop"])),
                        class: "icon is-small is-right"
                      }, _hoisted_5))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_6, [
                    _createElementVNode("i", {
                      class: _normalizeClass([{
                  'fa-angle-up': $setup.is_active,
                  'fa-angle-down': !$setup.is_active,
                }, "fal "]),
                      "aria-hidden": "true"
                    }, null, 2)
                  ])
                ])
              }
            : {
                name: "level-right",
                fn: _withCtx(() => [
                  (!$props.options.length)
                    ? _renderSlot(_ctx.$slots, "no-options", { key: 0 })
                    : ($setup.selected && $props.options.length)
                      ? _renderSlot(_ctx.$slots, "selected-option", {
                          key: 1,
                          option: $setup.selected,
                          class: _normalizeClass({ 'emphasize-on-load': $props.highlight})
                        }, () => [
                          _createTextVNode(_toDisplayString($setup.selected), 1)
                        ])
                      : ($props.options.length && !$setup.selected)
                        ? _renderSlot(_ctx.$slots, "default-not-selected-option", { key: 2 })
                        : _createCommentVNode("", true)
                ])
              }
        ]), 1024)
      ], 10, _hoisted_3)
    ]),
    _createElementVNode("div", {
      id: $props.name,
      class: "dropdown-menu",
      role: "menu"
    }, [
      _createElementVNode("div", {
        class: "dropdown-content",
        onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.options, (option) => {
          return (_openBlock(), _createElementBlock("div", {
            key: JSON.stringify(option),
            class: "dropdown-item is-hoverable",
            onClick: ($event: any) => ($setup.onSelect(option.value))
          }, [
            _renderSlot(_ctx.$slots, "option", { option: option }, () => [
              _createTextVNode(_toDisplayString(option), 1)
            ])
          ], 8, _hoisted_8))
        }), 128))
      ])
    ], 8, _hoisted_7)
  ], 10, _hoisted_1))
}